<template>
    <div class="main">
        <div class="orders-overview mt-1">
            <div class="row">

                <div class="mx-auto col-md-6 mt-5">
                    <b-card
                        no-body
                        border-variant="primary"
                        header="Select A Store"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                    >
                        <b-card-body class="vertical-scroll">

                            <div>
                                <div class="continue" v-if="continueWithStoreMessage">
                                    <p>{{continueWithStoreMessage}}</p>
                                    <b-button @click="continueWithStore">Continue</b-button>
                                    <hr>
                                </div>

                                <b-form-select 
                                    :options="parentStores" 
                                    @change="updateParentStoreId"
                                >
                                </b-form-select>
                                <b-form-select 
                                    :options="branches"
                                    size="sm"
                                    class="mt-3"
                                    @change="saveStoreId"
                                >
                                </b-form-select>
                            </div>
                            
                        </b-card-body>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            referer: null,
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.referer = from.fullPath
        });
    },
    computed : {
        continueWithStoreMessage() {
            if(localStorage.getItem('last-store-id')) {
                var storeId = Number(localStorage.getItem('last-store-id'))
                var store = this.$store.getters.BRANCHES.find((store) => {return store.id === storeId})

                if(store) 
                    return `You were shopping in ${store.parent.name}, ${store.name}?. Would you like to continue shopping from there?`
            }

            return null
        },
        currentStoreParentName() {
            return this.$store.getters.PARENT_STORE_NAME
        },
        parentStores() {
            var pStores = this.$store.getters.PARENT_STORES.map((store) => {
                return {"text": store.name, "value": store.id}
            })
            pStores.unshift({"text": 'Select a store', "value": null, "disabled": true})
            return pStores
        },
        branches() {
            var branches = this.$store.getters.BRANCHES.map((store) => {
                return {"text": store.name, "value": store.id}
            })
            branches.unshift({"text": 'Select a branch', "value": null, "disabled": true})
            return branches
        },
    },
    methods: {
        updateParentStoreId: function(e) {
            this.$store.commit('UPDATE_PARENT_STORE_ID', e)
        },
        continueWithStore: function() {
            var storeId = localStorage.getItem('last-store-id') || null
            this.saveStoreId(storeId)
        },
        saveStoreId: function (storeId) {
            this.$store.dispatch('SAVE_STORE_ID', storeId).then(() => {
                this.$store.dispatch('GET_STORE')
                this.$store.dispatch('GET_USER_CART')
                this.$store.dispatch('GET_USER_ORDERS')
                this.$store.dispatch('SUBSCRIBE_TO_EVENTS')

                if(!this.referer || this.referer === '/' || this.referer === '/login') {
                    this.$router.push('/shop')
                }else{
                    this.$router.push(this.referer)
                }
            })
        }
    }
}
</script>

<style scoped>
    .vertical-scroll.card-body{
        overflow-y: scroll;
        height: 75vh;
    }
</style>